<ng-select data-testid="search-autocomplete-select" id="searchAutocomplete" name="searchAutocomplete" bindLabel="name" class="pb-0" [class.required]="required" [items]="modelObservable | async"
   [ngModel]="getSelectedModel" [multiple]="multiple" [placeholder]="placeholder" [searchFn]="customSearchFunction" [loading]="loading && showLoader" [required]="required"
   [disabled]="disabled" [clearable]="clearable" (ngModelChange)="onSelectedModelChanged($event)" (search)="onSearchModels($event)" (focus)="doInitialSearch()"
   (open)="forceSearch()" appendTo="body">

   <ng-template ng-label-tmp let-item="item" let-clear="clear">
      @if (!!labelTemplate) {
      <ng-template [ngTemplateOutlet]="labelTemplate" [ngTemplateOutletContext]="{item: item, clear: clear}">
      </ng-template>
      } @else {

         <span>{{ item | internalLabel: defaultLabel }}</span>
         @if (clearable) {
            <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
         }
      
      }
      
   </ng-template>

   <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
      @if (!!optionTemplate) {
      <ng-template [ngTemplateOutlet]="optionTemplate" [ngTemplateOutletContext]="{item: item, searchTerm: search}">
      </ng-template>
      } @else {

         <span [highlightSearch]="highlightSearch" [searchTerm]="search">{{ item | internalLabel: defaultLabel }}</span>
      
      }
      
   </ng-template>

   @if (!!headerTemplate || !!typeForSuggestionsLabel) {
   <ng-template ng-header-tmp>
      @if (!!headerTemplate) {
         <ng-template [ngTemplateOutlet]="headerTemplate"></ng-template>
      } @else {

         <span class="type-for-suggestions">{{ typeForSuggestionsLabel }}</span>
      
      }
      
   </ng-template>
   }

   @if (!!footerTemplate) {
   <ng-template ng-footer-tmp>
      <ng-template [ngTemplateOutlet]="footerTemplate" [ngTemplateOutletContext]="{searchTerm: currentSearchTerm, close: closeSelect}"></ng-template>
   </ng-template>
   }
</ng-select>
